document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-wildstem-menu-button]');
  const drawer = document.querySelector('[data-wildstem-menu]');
  const overlay = document.querySelector('[data-wildstem-overlay]');
  if (!button || !drawer || !overlay) return;

  const close = () => {
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Open menu');
    drawer.hidden = true;
    overlay.hidden = true;
    document.body.classList.remove('wildstem-menu-open');
  };
  const open = () => {
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('aria-label', 'Close menu');
    drawer.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('wildstem-menu-open');
    drawer.querySelector('a')?.focus();
  };

  button.addEventListener('click', () => button.getAttribute('aria-expanded') === 'true' ? close() : open());
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
      close();
      button.focus();
    }
  });
});
